import { Link } from 'react-router-dom'

export function Footer() {
    const currentYear = new Date().getFullYear()

    return (
        <footer className="py-8 border-t border-paper-tertiary">
            <div className="max-w-6xl mx-auto px-8 sm:px-6 lg:px-8">
                <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
                    {/* Links */}
                    <nav className="flex items-center gap-6 text-sm text-ink-tertiary">
                        <Link
                            to="/privacy"
                            className="hover:text-ink transition-colors"
                        >
                            Privacy
                        </Link>
                        <Link
                            to="/terms"
                            className="hover:text-ink transition-colors"
                        >
                            Terms
                        </Link>
                        <a
                            href="mailto:hello@michela.app"
                            className="hover:text-ink transition-colors"
                        >
                            Contact
                        </a>
                    </nav>

                    {/* Copyright */}
                    <p className="text-sm text-ink-tertiary">
                        © {currentYear} Michela
                    </p>
                </div>
            </div>
        </footer>
    )
}
